import { commandScore } from "cmdk/dist/command-score";

interface FilterableOption {
  id: string;
  value: string;
}

export const createOptionFilter = (optionList: readonly FilterableOption[]) => {
  const labelById = new Map(optionList.map((option) => [option.id.trim().toLowerCase(), option.value]));

  return (id: string, search: string): number => commandScore(labelById.get(id) ?? id, search);
};
